import { useRef } from "react";

export const useRenerCounter = (screen) => {
    const renderCounter  = useRef(0);
    renderCounter.current = renderCounter.current + 1;
    console.log( `${screen}: `, renderCounter.current );
};

export function useFirstRender() {
    const ref = useRef(true);
    const firstRender = ref.current;
    ref.current = false;
    return firstRender;
  }